import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39f65560"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card verify-card",
  style: {"margin":"auto"}
}
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "mb-6 li-style" }
const _hoisted_4 = { class: "li-style" }
const _hoisted_5 = { class: "d-flex flex-column" }

import { ref, inject } from "vue";
import VerificationService from "@/projects/client/modules/verification/services/VerificationService";
import notification from "@/core/plugins/notification";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPending',
  setup(__props) {

const verificationCode = ref("");
const isLoading = ref(false);
const items = inject<any>("items");
const submit = async () => {
  isLoading.value = true;
  try {
    await VerificationService.codeVerify({
      code: verificationCode.value,
      hashId: items.value.hashId,
    });
    items.value.status = VerificationStatusTypes.CodeVerified;
    notification.success();
  } catch (error) {
    console.error(error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("fields.accountOpeningApplicationCompleted")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("fields.thankYouForApply")), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("fields.nextStep")), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("fields.accountOpeningApplicationRequest")), 1)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("fields.jpAccountRequest1")), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("fields.jpAccountRequest2")), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("fields.returnRequiredDocuments")), 1)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("fields.jpReturnRequiredDocuments1")), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("fields.jpReturnRequiredDocuments2")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_input, {
        modelValue: verificationCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((verificationCode).value = $event)),
        class: "mt-4",
        style: {"width":"240px"},
        disabled: isLoading.value,
        placeholder: _ctx.$t('fields.authenticationNumber'),
        clearable: ""
      }, null, 8, ["modelValue", "disabled", "placeholder"]),
      _createVNode(_component_el_button, {
        type: "success",
        class: "mt-4",
        style: {"width":"240px"},
        onClick: submit,
        disabled: isLoading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})